'use strict';

var appDom = require('./app-dom');

var isFirstImage = function(index) {

	return !index;

};

var isLastImage = function(index, data) {

	return index === data.length - 1;

};

var isSlideshowZoomActive = function() {

	return appDom.app.hasClass('app--is-slideshow-zoom');

};

var isSlideshowCompareActive = function() {

	return appDom.app.hasClass('app--is-slideshow-compare');

};

var isSlideshowCompareFrame = function() {

	return appDom.app.hasClass('app--is-slideshow-compare-frame');

};

module.exports = {
	isFirstImage: isFirstImage,
	isLastImage: isLastImage,
	isSlideshowZoomActive: isSlideshowZoomActive,
	isSlideshowCompareActive: isSlideshowCompareActive,
	isSlideshowCompareFrame: isSlideshowCompareFrame
};
